import { buildInstructionsUrl, getItemInstructionsServiceUrl } from './instructionsUrl';
import { buildCimDocForItemPreview, encodeCimDoc } from './cimDoc';
export class RenderingUrlTooLargeError extends Error {
    constructor(renderingUrl) {
        super('RenderingUrl is too Large');
        Object.defineProperty(this, "renderingUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.setPrototypeOf(this, RenderingUrlTooLargeError.prototype);
        this.renderingUrl = renderingUrl;
    }
}
export function buildRenderingBaseWithoutInstructions({ referer, tenantId, view, width, bgColor, format, showerr }) {
    const MAX_WIDTH = 10000;
    const baseUrl = `https://rendering.documents.cimpress.io/v1/${tenantId}/preview`;
    const params = new URLSearchParams();
    if (width) {
        params.append('width', Math.min(Math.ceil(width), MAX_WIDTH).toString());
    }
    params.append('referer', referer);
    if (format) {
        params.append('format', format);
    }
    if (bgColor) {
        params.append('bgColor', bgColor);
    }
    if (view.type === 'scene') {
        params.append('scene', view.scene.url);
    }
    if (showerr !== undefined) {
        params.set('showerr', `${showerr}`);
    }
    return {
        baseUrl,
        params,
    };
}
export const MAX_URL_LENGTH = 8000;
export function buildRenderingUrl({ cimDocUrl, referer, tenantId, view, width, bgColor, format, showerr }) {
    const { baseUrl, params } = buildRenderingBaseWithoutInstructions({ referer, tenantId, view, width, bgColor, format, showerr });
    if (view.type === 'panel') {
        if (!cimDocUrl) {
            throw new Error('cimDocUrl not provided');
        }
        params.append('instructions_uri', buildInstructionsUrl({ cimDocUrl, surfaceOrdinals: view.panel.page }));
    }
    else if (view.type === 'scene') {
        if (!cimDocUrl) {
            throw new Error('cimDocUrl not provided');
        }
        params.append('instructions_uri', buildInstructionsUrl({ cimDocUrl, ignoreProjection: view.scene.type === 'dynamic' }));
    }
    else {
        params.append('instructions_uri', buildInstructionsUrl({
            cimDocUrl: encodeCimDoc({ cimDoc: buildCimDocForItemPreview({ cimDocInfo: view.cimDocInfo, item: view.item }) }),
            instructionsServiceUrl: getItemInstructionsServiceUrl(),
        }));
    }
    const renderingUrl = `${baseUrl}?${params.toString()}`;
    if (renderingUrl.length >= MAX_URL_LENGTH) {
        throw new RenderingUrlTooLargeError(renderingUrl);
    }
    return renderingUrl;
}
//# sourceMappingURL=renderingUrl.js.map